import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { Checkbox } from '@mui/material';
import Loading from '../Loading/Loading';
import { PaperStyled, WrapperAutocomplete } from './styles';
import ArrowDown from './ArrowDown';
import ArrowUp from './ArrowUp';
import { CloseList, WrapperEndAdornment } from 'src/components/QualifyPropertyHabi/styles';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PaperMy = function (props) {
  return (<PaperStyled {...props} anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }} />)
}

export default function AutocompleteMui({ optionKey, options, loading, placeholder, ...props }) {
  const [open, setOpen] = useState(false)
  const handleOpen = () => {
    setOpen(prev => !prev)
  }
  return (
    <WrapperAutocomplete>
      <Autocomplete
        {...props}
        multiple
        open={open}
        options={options}
        loading={loading}
        disableCloseOnSelect
        className={`pcom-autocomplete ${props.className}`}
        getOptionLabel={(option) => optionKey ? option[optionKey] : option}
        PaperComponent={PaperMy}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {optionKey ? option[optionKey] : option}
            </li>
          );
        }}
        renderInput={(params) => {
          return (
            <>
              {open && <CloseList onClick={handleOpen} className='close-list' />}
              <div onClick={handleOpen} style={{ cursor: 'pointer' }}>
                <TextField {...params} placeholder={placeholder}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <WrapperEndAdornment>
                        {loading ? <Loading className='loading' /> : null}
                        {open ? <ArrowUp /> : <ArrowDown />}
                      </WrapperEndAdornment>
                    ),
                  }} />
              </div>

            </>
          )
        }}
      />
    </WrapperAutocomplete>

  );
}
